import type { QuestionRatingModelData } from '@coorum-research/shared-common/types/survey-json.type'
import type { Question } from 'survey-core'
import type { ISurveyCreator } from 'survey-react-ui'
import { SurveyQuestion } from 'survey-react-ui'

type Props = {
  creator: ISurveyCreator
  question: Question
}

/**
 * answer 回答表示用のコンポーネント
 * question type === 'rating'
 */
export function SurveyQuestionAnswerRating({ creator, question }: Props) {
  const modelData = question.toJSON() as QuestionRatingModelData

  return (
    <>
      {SurveyQuestion.renderQuestionBody(creator, question)}
      {modelData.showCommentArea && question.comment.length > 0 && <div className="mt-2">{question.comment}</div>}
    </>
  )
}
